export default function genererCriteresRechercheClient(isCartographie) {
  const values = {
    auto: '',
    typesPointVente: [],
    codesMagasin: [],
    comptesComptable: [],
    secteursActiviteIds: [],
    codesPostaux: [],
    adresses: [],
    nomsCommercialOuNomsJuridique: [],
    commercialIds: [],
    codes: [],
    villes: [],
    archive: false,
    prospect: null,
    typologie: [],
    blocageLevel: [],
    tiers: [],
    avecCoordonnees: null,
    marqueIds: [],
    estLieuStockage: null,
    tagIds: [],
  };
  if (isCartographie) {
    values.avecCoordonnees = true;
  }
  return values;
}
